import { Injectable } from '@angular/core';
import { AppConfig } from '../types/app-config.type';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';

/**
 * This service is used to initialize the app by setting the environment specific URL's
 *
 * **Note**: Should be called within the `APP_INITIALIZER` portion of your app (see README.md).
 */
@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  /**
   * Application configuration which stores the URL's required for application
   */
  private appConfig: AppConfig;

  /**
   * Constructor injecting all the dependencies.
   *
   * @param httpClient to fetch the environment specific configuration.
   */
  public constructor(
    private httpClient: HttpClient
  ) {}

  /**
   * This method loads the environment specific configuration on application bootstrap
   * and assign the config to @AppConfig
   * @return promise for resolving the configuration
   */
  public loadAppConfig(): Promise<AppConfig> {
    return this.httpClient.get<AppConfig>('/config.json')
      .pipe(
        tap((response) => {
          this.appConfig = response;
        })
      )
      .toPromise<AppConfig>();
  }

  /**
   * Return the environment specific API URL required for the backend API's
   * @return the API URL
   */
  public getAPIUrl(): string {
    return this.appConfig.apiURL;
  }

  /**
   * Return the environment specific Xliff URL required for the translation bundle
   * @return the Xliff URL
   */
  public getXliffUrl(): string {
    return this.appConfig.xliffURL;
  }
}
